module.exports = __webpack_public_path__ + "media/us-banner.823ed874.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/en/images/pptxgen/us-banner.png
// module id = 886
// module chunks = 0